import { TrueType } from 'library/ts/utilities/modules/enums/TrueType';
import * as Type from 'library/ts/utilities/modules/Type';
export const sortByPropertyName = (object) => {
    let output;
    if (typeof object === TrueType.OBJECT && Object.keys(object).length > 0) {
        output = {};
        Object.keys(object).sort().forEach((key) => {
            output[key] = sortByPropertyName(object[key]);
        });
        return output;
    }
    return object;
};
export const sort = (object) => {
    const sortedObj = {};
    const keys = Object.keys(object);
    keys.sort((key1, key2) => {
        key1 = key1.toLowerCase();
        key2 = key2.toLowerCase();
        if (key1 < key2)
            return -1;
        if (key1 > key2)
            return 1;
        return 0;
    });
    for (const index in keys) {
        const key = keys[index];
        if (typeof object[key] == TrueType.OBJECT && !(object[key] instanceof Array)) {
            sortedObj[key] = sort(object[key]);
        }
        else {
            sortedObj[key] = object[key];
        }
    }
    return sortedObj;
};
export const equal = (a = {}, b = {}) => {
    const aProps = Object.getOwnPropertyNames(a);
    const bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (let i = 0; i < aProps.length; i++) {
        const propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
};
export const jsonEqual = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
};
export const clone = (object) => {
    if (Type.isObject(object) === false || Type.isNull(object))
        return object;
    const copy = {};
    Object.keys(object).forEach((key) => {
        copy[key] = object[key];
    });
    return copy;
};
export const cloneDeep = (object) => {
    return JSON.parse(JSON.stringify(object));
};
export const cloneForPostMessage = (object) => {
    return removeEmptyKeys(cloneDeep(object));
};
export const mergeDeep = (target, ...sources) => {
    if (!sources.length)
        return target;
    const source = sources.shift();
    if (Type.isObject(target) && Type.isObject(source)) {
        for (const key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                if (Type.isObject(source[key])) {
                    if (!target[key])
                        Object.assign(target, { [key]: {} });
                    mergeDeep(target[key], source[key]);
                }
                else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
    }
    return mergeDeep(target, ...sources);
};
export const assign = (target, ...args) => {
    return Object.assign(target || {}, ...args);
};
export const deepFreeze = (target) => {
    const keys = Object.keys(target);
    keys.forEach((key) => {
        if (typeof target[key] === 'object' && Object.isFrozen(target[key]) === false) {
            deepFreeze(target[key]);
        }
    });
    return Object.freeze(target);
};
export const removeEmptyKeys = (obj) => {
    if (Type.isObject(obj)) {
        Object.keys(obj).forEach((key) => {
            const value = obj[key];
            if (Type.isEmpty(value)) {
                delete obj[key];
            }
            removeEmptyKeys(value);
        });
    }
    return obj;
};
export const mapMerge = (sourceObject = {}, targetObject = {}, fillOutMap = []) => {
    if (!Type.isObject(sourceObject)) {
        sourceObject = {};
    }
    if (!Type.isObject(targetObject)) {
        targetObject = {};
    }
    if (!Type.isArray(fillOutMap)) {
        fillOutMap = [];
    }
    fillOutMap.forEach((obj) => {
        for (let i = 0; i < obj.from.length; i++) {
            const oneFrom = obj.from[i];
            if (!Type.isEmpty(sourceObject[oneFrom])) {
                targetObject[obj.to] = sourceObject[oneFrom];
            }
            if (!Type.isEmpty(obj?.default) && Type.isEmpty(targetObject[obj.to])) {
                targetObject[obj.to] = obj.default;
            }
            if (!Type.isEmpty(obj?.override)) {
                targetObject[obj.to] = obj.override;
            }
        }
    });
    return targetObject;
};
export const enumToObject = (enumType) => {
    const values = {};
    for (const key in enumType) {
        if (typeof enumType[key] === 'string') {
            values[key] = enumType[key];
        }
    }
    return values;
};
